import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import Button from '../ui/Button';
import { useAuth } from '../../context/AuthContext';

const Shell = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: row;
  }
`;

const Sidebar = styled.aside`
  background: ${({ theme }) => theme.colors.bgDarker};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  padding: 1.25rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 240px;
    flex-shrink: 0;
    border-bottom: none;
    border-right: 1px solid ${({ theme }) => theme.colors.border};
    min-height: 100vh;
    position: sticky;
    top: 0;
  }
`;

const Brand = styled.p`
  font-family: ${({ theme }) => theme.fonts.display};
  font-size: 1.6rem;
  color: ${({ theme }) => theme.colors.gold};
  margin-bottom: 1.5rem;
`;

const NavList = styled.nav`
  display: flex;
  gap: 0.5rem;
  overflow-x: auto;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: column;
    overflow-x: visible;
  }
`;

const NavItem = styled(NavLink)`
  min-height: 44px;
  display: flex;
  align-items: center;
  padding: 0.6rem 0.9rem;
  border-radius: ${({ theme }) => theme.radii.sm};
  color: ${({ theme }) => theme.colors.textMuted};
  white-space: nowrap;
  font-weight: 500;

  &:hover {
    background: rgba(255, 255, 255, 0.05);
    color: ${({ theme }) => theme.colors.text};
  }

  &.active {
    background: ${({ theme }) => theme.gradients.primary};
    color: ${({ theme }) => theme.colors.bgDarker};
  }
`;

const Content = styled.main`
  flex: 1;
  padding: 1.5rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 2.5rem;
  }
`;

const LogoutWrap = styled.div`
  margin-top: 1.5rem;
`;

function AdminLayout() {
  const { logout, usuario } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/admin/login', { replace: true });
  };

  return (
    <Shell>
      <Sidebar>
        <Brand>Admin · Chingada</Brand>
        <NavList>
          <NavItem to="/admin/reservaciones">Reservaciones</NavItem>
          <NavItem to="/admin/banners">Banners</NavItem>
          <NavItem to="/admin/menu">Menú</NavItem>
        </NavList>
        <LogoutWrap>
          <Button $variant="ghost" onClick={handleLogout} style={{ width: '100%' }}>
            Cerrar sesión{usuario ? ` (${usuario})` : ''}
          </Button>
        </LogoutWrap>
      </Sidebar>
      <Content>
        <Outlet />
      </Content>
    </Shell>
  );
}

export default AdminLayout;
